import api from "@/plugins/api/EntryPoint";

export default {
  getFaq(callBackFn, lang) {
    return api.get(`settings/faq?lang=${lang}`, callBackFn);
  },
};
